var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"notificationBelowHeaderSpacer",class:_vm.cssClasses,style:({ height: _vm.spacerHeight + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }